import React from 'react';
import { sumBy, meanBy, map } from 'lodash';
import DiffAndChange from '../DiffAndChange';
import { splitByThousands, convertToThousands } from '../../../helpers/NumberFormatter';

export {
	summaryFooter,
	diffFooter
}

function summaryFooter(totals, key) {
	return <React.Fragment>
		{convertToThousands(totals[`curr_${key}_income`])}
		<br/>
		{convertToThousands(totals[`curr_${key}_quantity`])}
	</React.Fragment>;
}

function diffFooter(totals, key) {
	return <React.Fragment>
		<DiffAndChange className="percent-value" field={`${key}_income`} item={totals}/>
		<br />
		<DiffAndChange className="percent-value" field={`${key}_quantity`} item={totals}/>
	</React.Fragment>
}
